module.exports = __webpack_public_path__ + "img/1688693704976-IMG-20230707-WA0007.jpg.3bcfe033.webp";